import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserDetailsComponent } from './user-details.component';
import { FormElementsModule } from '../../../form-elements';
import { CommonComponentsModule } from '../../../common-components';
import { HttpClientModule } from '@angular/common/http';
import { UserDetailsRouteModule } from '../user-details-route.module';
import { CreateUserComponent } from '../components/create-user/create-user.component';
import { ListUserComponent } from '../components/list-user/list-user.component';
import { QuestionaryComponent } from '../components/questionary/questionary.component';
import { PersonalDetailsComponent } from '../components/personal-details/personal-details.component';
import { YourPensionComponent } from '../components/your-pension/your-pension.component';
import { DependantDetailsComponent } from '../components/dependant-details/dependant-details.component';
import { ProductChoiceComponent } from '../components/product-choice/product-choice.component';
import { AnnuitantDetailsComponent } from '../components/annuitant-details/annuitant-details.component';
import { YourOptionsQuestionsComponent } from '../components/your-options-questions/your-options-questions.component';
import { AfterLoginComponent } from '../components/auth/after-login/after-login.component';
import { DependantHealthandlifestyleComponent } from '../components/dependant-healthandlifestyle/dependant-healthandlifestyle.component';
import { DependantMedicalConditionsComponent } from '../components/dependant-medical-conditions/dependant-medical-conditions.component';
import { YourCedingFundComponent } from '../components/your-ceding-fund/your-ceding-fund.component';
import { RegistrationComponent } from 'src/app/pages/user-details/components/registration/registration.component';
import { PostRegistrationComponent } from 'src/app/pages/user-details/components/post-registration/post-registration.component';
import {UnSupportedBrowserComponent  } from '../components/un-supported-browser/un-supported-browser.component';
import { LogoutComponent } from 'src/app/pages/user-details/components/logout/logout.component';
import { GuidanceAndAdviceComponent } from '../components/guidance-and-advice/guidance-and-advice.component';

@NgModule({
    declarations: [
        UserDetailsComponent,
        CreateUserComponent,
        ListUserComponent,
        QuestionaryComponent,
        PersonalDetailsComponent,
        YourPensionComponent,
        YourCedingFundComponent,
        AnnuitantDetailsComponent,
        DependantDetailsComponent,
        ProductChoiceComponent,
        YourOptionsQuestionsComponent,
        AfterLoginComponent,
        
        DependantHealthandlifestyleComponent,
        DependantMedicalConditionsComponent,
        PostRegistrationComponent,
        RegistrationComponent,
        UnSupportedBrowserComponent,
        UnSupportedBrowserComponent,
        LogoutComponent,
        GuidanceAndAdviceComponent
    ],
    imports: [
        CommonModule,
        FormElementsModule,
        FormsModule,
        ReactiveFormsModule,
        CommonComponentsModule,
        HttpClientModule,
        UserDetailsRouteModule
    ],
    providers: [DatePipe]

})
export class UserDetailsModule { }
